import React, { useRef, useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';

import getValidationErrors from '../../utils/getValidationErrors';

import AuthInput from '../../components/AuthInput'
import Loader from '../../components/Loader'

import { useAuth } from '../../hooks/AuthContext';

import Logo from '../../assets/image 6.svg';

import { Container, Form } from './styles';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);
  const { signIn } = useAuth();

  const handleSubmit = useCallback(async (data) => {
    
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object().shape({
        username: Yup.string().required('Usuário necessário'),
        password: Yup.string().required('Senha necessária'),
      });

      await schema.validate(data, { abortEarly: false });
      setLoading(true);
      await signIn({
        username: data.username,
        password: data.password
      });
      setLoading(false);
      toast.success('Seja bem-vindo ao OCARIoT')

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        formRef.current?.setErrors(errors);

        return;
      }
      setLoading(false);
      toast.error('Usuário ou senha inválidos. Por favor tente novamente');

    }
  }, [signIn]);

  return (
    <Container>
      <Form ref={formRef} onSubmit={handleSubmit}>
        <img src={Logo} alt="Ocariot" />
        <AuthInput type="text" name="username" placeholder="Usuário"/>
        <AuthInput  name="password" placeholder="Senha" icon={true}/>
        <Link to="/forget-password">Esqueceu a senha?</Link>
        <button id="login-button" type="submit">{loading ? <Loader color = 'white'/> : 'Entrar'}</button>
      </Form>

    </Container>
  );
}

export default Login;